import { memo, FC } from 'react'
import styles from './index.module.scss'

interface Props {
  src?: string
  width?: number
  height?: number
  style?: object
}

const NetworkLogo: FC<Props> = ({ src, width, height, style = {} }) => {
  const sty = {
    width,
    height,
    ...style,
  }
  return <img alt="" src={src} className={styles.logo} style={sty} />
}

export default memo(NetworkLogo)
